export default {
    downloadApp: "Download the app on your device's store",
};
